import { render } from "./PDetails.vue?vue&type=template&id=a11cb746&scoped=true"
import script from "./PDetails.vue?vue&type=script&lang=js"
export * from "./PDetails.vue?vue&type=script&lang=js"

import "./PDetails.vue?vue&type=style&index=0&id=a11cb746&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11cb746"]])

export default __exports__